import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import useLocales from "src/hooks/useLocales";

import ChangePasswordDialog from "./ChangePasswordDialog/ChangePasswordDialog";

// ----------------------------------------------------------------------

export const PasswordRow = () => {
	const [show, setShow] = useState(false);
	const { translate } = useLocales();

	return (
		<Stack
			flexDirection={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			sx={{ mt: 2 }}
			justifyContent={"space-between"}
		>
			<Stack flexDirection={"row"} alignItems={"center"}>
				<Typography width={200} variant='subtitle1'>
					{translate("profile.password")}
				</Typography>
				<Typography variant='body2'>{"*********"}</Typography>
			</Stack>
			<Button variant='contained' onClick={() => setShow(true)} sx={{ mt: { xs: 4, sm: 0 } }}>
				{translate("profile.change_password")}
			</Button>
			<ChangePasswordDialog onClose={() => setShow(false)} show={show} />
		</Stack>
	);
};

export default PasswordRow;
